export const userStatusList = [
    {key: 1, value: "ACTIVO"},
    {key: 2, value: "INACTIVO"},
];

export const appAdminUserStatusList = [
    {key: 1, value: "ACTIVO"},
    {key: 2, value: "INACTIVO"},
];

export const hotelStatusList = [
    {key: 1, value: "ACTIVO"},
    {key: 2, value: "INACTIVO"},
];

export const colorList = [
    {key: 'yellow', value: "AMARILLO"},
    {key: 'blue', value: "AZUL"},
    {key: 'white', value: "BLANCO"},
    {key: 'golden', value: "DORADO"},
    {key: 'grey', value: "GRIS"},
    {key: 'cherry', value: "GUINDO"},
    {key: 'black', value: "NEGRO"},
    {key: 'silver', value: "PLATEADO"},
    {key: 'red', value: "ROJO"},
    {key: 'green', value: "VERDE"},
];

export const vehicleTypeList = [
    {key: 'A', value: "3 PASAJEROS MÁX."},
    {key: 'B', value: "4 PASAJEROS MÁX."},
    {key: 'C', value: "8 PASAJEROS MÁX."}
];

export const vehicleStatusList = [
    {key: 1, value: "ACTIVO"},
    {key: 2, value: "INACTIVO"},
];

export const guestStatusList = [
    {key: 1, value: "REGISTRADO", color: 'default'},
    {key: 2, value: "ACTIVO", color: 'success'},
    {key: 3, value: "INACTIVO", color: 'danger'},
];

export const profileList = [
    {key: 'MANAGEMENT', value: "GERENCIA"},
    {key: 'CUSTOMER_SERVICE', value: "CUSTOMER SERVICE"},
    {key: 'HOTEL', value: "RECEPCIÓN"},
];

export const rideStatusList = [
    {key: 1, value: "PENDIENTE"},
    {key: 2, value: "ASIGNADO"},
    {key: 3, value: "CANCELADO"},
    {key: 4, value: "HACIA PUNTO DE RECOJO"},
    {key: 5, value: "EN PUNTO DE RECOJO"},
    {key: 6, value: "EN VIAJE"},
    {key: 7, value: "FINALIZADO"}
];



// WEBPACK FOOTER //
// ./src/util/selectOptions.js